// extracted by mini-css-extract-plugin
export var errorIcon = "_qh-1";
export var nameLogo = "_qh-0";